import { useEffect, useState } from 'react';

export function useBreakpoint(breakpoint: number) {
  const [isSmaller, setIsSmaller] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const checkSize = () => {
      setIsSmaller(window.innerWidth < breakpoint);
    };

    window.addEventListener('resize', checkSize);
    return () => window.removeEventListener('resize', checkSize);
  }, [breakpoint]);

  return isSmaller;
}
